var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "lang-select" }, [
    _c(
      "span",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.language !== "en",
            expression: "language !== 'en'",
          },
        ],
        class: { active: _vm.language === "en" },
        on: {
          click: function ($event) {
            return _vm.handleSetLanguage("en")
          },
        },
      },
      [_vm._v("English")]
    ),
    _vm._v(" "),
    _c(
      "span",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.language !== "spanish",
            expression: "language !== 'spanish'",
          },
        ],
        class: { active: _vm.language === "spanish" },
        on: {
          click: function ($event) {
            return _vm.handleSetLanguage("spanish")
          },
        },
      },
      [_vm._v("Español")]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }